module.exports = __webpack_public_path__ + "static/media/promoDiscount.ee881105.svg";